import CardDetail from "@/components/CardDetail";
import { Stack, useLocalSearchParams, useRouter } from "expo-router";

export default function CardDetailRoute() {
  const router = useRouter();
  const { cardId } = useLocalSearchParams<{ cardId?: string }>();

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <CardDetail cardId={cardId ?? ""} onClose={() => router.back()} />
    </>
  );
}
